import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapToggle = React.lazy(function () {
    return import('../../bootstrap-components/components/BTDraftEditor');
});
var bootStrapToggle = function (props) {
    return (React.createElement(BootStrapToggle, __assign({}, props), props.children));
};
export var DraftEditor = function (props) {
    var componentToDisplay = bootStrapToggle(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
DraftEditor.defaultProps = {
    styleName: 'primary',
    label: 'TextBox',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=DraftEditor.js.map